import React from 'react';
import { FaAngleUp } from 'react-icons/fa';

import './style/titleStep.scss';

const QuestionTitle = (props) => {
	const { titleStep, target } = props;

	if (titleStep === '' || titleStep === undefined) {
		return null;
	}

	return (
		<div className="component-title-step droppable">
			<h3>
				{titleStep}
			</h3>
			<a className="dropdown-button collapsed" data-toggle="collapse" href={`#${target}`}>
				<FaAngleUp />
			</a>
		</div>
	);
};

export default QuestionTitle;
